import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import MembershipAndBilling from './MembershipAndBilling';
import Default from './Default';

const SECTION_MAP = {
  MembershipAndBillingSection: MembershipAndBilling,
};

const getSection = (sectionType) => {
  const section = SECTION_MAP[sectionType];
  if (!section) {
    return Default;
  }
  return section;
};

const Section = ({
  sectionResource: resource,
}) => {
  const links = resource.relationships().list().filter(link => link.meta('type') === relationshipType.hyperlink || link.meta('type') === relationshipType.pagelink || link.meta('type') === relationshipType.modalLink);

  const SectionComponent = getSection(resource.type());

  return (
    <SectionComponent
      title={resource.attr('title')}
      description={resource.attr('subtitle')}
      links={links}
      resource={resource}
    />
  );
};

Section.defaultProps = {
};

Section.propTypes = {
  sectionResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Section;
